module.exports = __webpack_public_path__ + "media/images/whatsapp-50abe40b63ec115b7146ab1fe51cf628.png";